export const INTEGRATION_SOURCES = {
  HUBSPOT: 'HUBSPOT',
  SHOPIFY: 'SHOPIFY',
  ECOMM: 'ECOMM',
  ECOMM_API: 'ECOMM_API'
};

/**
 * @deprecated
 */
export const INTEGRATION_IDENTIFIERS = {
  ECOMM: 'ip__ecomm_bridge__ecomm_synced'
};
export const PRODUCT_SHOPIFY_IDENTIFIER_PROPERTY = 'ip__shopify__vendor';
export const DEAL_SHOPIFY_IDENTIFIER_PROPERTY = 'ip__shopify__source_name';
export const LINE_ITEM_SHOPIFY_IDENTIFIER_PROPERTY = 'ip__shopify__title';
export const READABLE_INTEGRATION_SOURCES = {
  HUBSPOT: 'HubSpot'
};

/** Added for tracking ecomm usage: https://git.hubteam.com/hubspotprotected/settings-ui-products/issues/698 */
export const SHOPIFY_APP_IDS = {
  QA: '1161155',
  PROD: '51381'
};
export const QUICKBOOKS_APP_IDS = {
  QA: '1165378',
  PROD: '188574'
};
export const QUICK_BOOKS_DATA_SYNC_APP_IDS = {
  QA: '1920452',
  PROD: '542129'
};